import { crudRequest } from '@/services/api';

const state = {}
for (let dsIndex = 0; dsIndex < 2; dsIndex++) {
  state[`preveCenter${dsIndex}`] = {}
}

export default {
  namespace: 'preveCenter',
  state: { ...state },

  effects: {
    *preveCenter({ payload: { data, dsIndex } }, { call, put, select }) {
      yield put({ type: 'updateState', payload: { [`preveCenter${dsIndex}`]: data[0].result } })
    }
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}